export * from './confirmationModal.service';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/confirmationModal/index.ts